import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Package, ShieldCheck, FileSpreadsheet, Mail } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const [configured, setConfigured] = useState(true);

  useEffect(() => {
    api.get("/config").then((r) => setConfigured(r.data.google_configured)).catch(() => {});
  }, []);

  useEffect(() => {
    if (user) window.location.href = "/";
  }, [user]);

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-950 text-white">
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-blue-950/60" />
        <div className="relative z-10 flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-blue-600 grid place-items-center">
            <Package className="h-6 w-6" />
          </div>
          <span className="font-display text-xl font-bold tracking-tight">MM Operations Hub</span>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="font-display text-4xl xl:text-5xl font-extrabold leading-tight">
            Da Delivery Note PDF<br />al file ordine MM<br />in pochi secondi.
          </h1>
          <div className="space-y-4 text-slate-300">
            <Feature icon={<FileSpreadsheet className="h-5 w-5 text-blue-400" />} text="Estrazione dati automatica con AI" />
            <Feature icon={<ShieldCheck className="h-5 w-5 text-blue-400" />} text="Anteprima e correzione prima dell'invio" />
            <Feature icon={<Mail className="h-5 w-5 text-blue-400" />} text="Invio dal tuo indirizzo Gmail" />
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-500">3PL Integration &middot; MM Operations</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm space-y-8">
          <div className="lg:hidden flex items-center gap-3 justify-center">
            <div className="h-10 w-10 rounded-xl bg-blue-600 grid place-items-center">
              <Package className="h-5 w-5" />
            </div>
            <span className="font-display text-lg font-bold">MM Operations Hub</span>
          </div>
          <div className="space-y-2 text-center">
            <h2 className="font-display text-2xl font-bold">Accedi</h2>
            <p className="text-sm text-slate-400">
              Usa il tuo account Google per accedere e inviare gli ordini dal tuo indirizzo email.
            </p>
          </div>

          {!configured && (
            <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-4 text-sm text-amber-300" data-testid="google-not-configured-alert">
              Google OAuth non ancora configurato. Inserisci le credenziali Google Cloud per abilitare l'accesso.
            </div>
          )}

          <Button
            data-testid="google-login-button"
            onClick={login}
            disabled={!configured}
            className="w-full h-12 bg-white text-slate-900 hover:bg-slate-100 font-semibold gap-3"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5" />
            Accedi con Google
          </Button>

          <p className="text-center text-xs text-slate-500">
            Verranno richiesti i permessi per inviare email a tuo nome (gmail.send).
          </p>
        </div>
      </div>
    </div>
  );
}

const Feature = ({ icon, text }) => (
  <div className="flex items-center gap-3">
    <div className="h-9 w-9 rounded-lg bg-white/5 border border-white/10 grid place-items-center">{icon}</div>
    <span className="text-sm">{text}</span>
  </div>
);
